var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "filetype_pdf") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 8,
    y: 4,
    width: 24,
    height: 32,
    rx: 1
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-8.3%",
    y: "-3.1%",
    width: "116.7%",
    height: "112.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.127109646   0 0 0 0 0.0591805127   0 0 0 0 0.197180707  0 0 0 0.16 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.125490196   0 0 0 0 0.0588235294   0 0 0 0 0.196078431  0 0 0 0.12 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "filetype_pdf",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "Paper"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FBF9F6",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "dash",
    fill: "#C34646",
    x: 4,
    y: 8,
    width: 20,
    height: 11,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.52539062,16 L8.52539062,14.246582 L9.42431641,14.246582 C10.0144857,14.246582 10.4764811,14.1058757 10.8103027,13.8244629 C11.1441243,13.5430501 11.3110352,13.1585286 11.3110352,12.6708984 C11.3110352,12.3496094 11.2347005,12.0630697 11.0820312,11.8112793 C10.929362,11.5594889 10.7111816,11.3652344 10.4274902,11.2285156 C10.1437988,11.0917969 9.81510417,11.0234375 9.44140625,11.0234375 L9.44140625,11.0234375 L7.5,11.0234375 L7.5,16 L8.52539062,16 Z M9.44140625,13.4160156 L8.52539062,13.4160156 L8.52539062,11.8540039 L9.46533203,11.8540039 C9.71826172,11.8585612 9.91650391,11.9360352 10.0600586,12.0864258 C10.2036133,12.2368164 10.2753906,12.4339193 10.2753906,12.6777344 C10.2753906,12.9147135 10.2041829,13.0970052 10.0617676,13.2246094 C9.91935221,13.3522135 9.7125651,13.4160156 9.44140625,13.4160156 L9.44140625,13.4160156 Z M13.8366406,16 C14.271862,15.9977214 14.6626497,15.8974609 15.0090039,15.6992188 C15.3553581,15.5009766 15.6236686,15.2218424 15.8139355,14.8618164 C16.0042025,14.5017904 16.0993359,14.0904948 16.0993359,13.6279297 L16.0993359,13.6279297 L16.0993359,13.3989258 C16.0993359,12.9363607 16.0024935,12.5233561 15.8088086,12.1599121 C15.6151237,11.7964681 15.3456738,11.5161947 15.000459,11.3190918 C14.6552441,11.1219889 14.2638867,11.0234375 13.8263867,11.0234375 L13.8263867,11.0234375 L12.2951367,11.0234375 L12.2951367,16 L13.8366406,16 Z M13.8161328,15.1762695 L13.3205273,15.1762695 L13.3205273,11.8540039 L13.8263867,11.8540039 C14.229707,11.8540039 14.5361849,11.9844564 14.7458203,12.2453613 C14.9554557,12.5062663 15.0602734,12.8896484 15.0602734,13.3955078 L15.0602734,13.3955078 L15.0602734,13.6586914 C15.0557161,14.1463216 14.9474805,14.5211589 14.7355664,14.7832031 C14.5236523,15.0452474 14.2171745,15.1762695 13.8161328,15.1762695 L13.8161328,15.1762695 Z M18.1498437,16 L18.1498437,13.9663086 L20.1185937,13.9663086 L20.1185937,13.1391602 L18.1498437,13.1391602 L18.1498437,11.8540039 L20.3646875,11.8540039 L20.3646875,11.0234375 L17.1244531,11.0234375 L17.1244531,16 L18.1498437,16 Z",
    id: "PDF",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.a40ce7694d23c0245866edf991e28512.svg";
export { ForwardRef as ReactComponent };